const tabCfgAry = [
  {
    key: "user",
  },
  {
    key: "usds",
    labelKey: "market.subTabCrypto",
    buyCoinAry: ["usdt", "pax", "tusd", "ausd", "usdc", "ust", "xtusd", "busd"], //过滤包含的买方币数组
  },
  // {
  //   key: "etf",
  //   label: "ETF",
  //   noHidden: true, //出现该字段，取消"将浅度隐藏的市场过滤掉"逻辑
  // },
  {
    key: "btc",
    label: "BTC",
    buyCoinAry: ["btc"],
  },
  {
    key: "eth",
    label: "ETH",
    buyCoinAry: ["eth"],
  },
  // 法币合约：合并 AED/BRL/SAR 为一个 Crypto tab，不再区分法币
  {
    key: "fiat",
    labelKey: "market.subTabCrypto",
    buyCoinAry: ["aed", "brl", "sar"],
  },
  // 股票 / 大宗商品（按 plates 261/260 过滤，法币弹窗在法币后、U本位弹窗在 USD 后）
  {
    key: "stocks",
    labelKey: "market.subTabStocks",
  },
  {
    key: "commodities",
    labelKey: "market.subTabCommodities",
  },
  //ALTS
  {
    key: "xt",
    label: "XT",
    buyCoinAry: ["xt"],
    group: "ALTS",
  },
  {
    key: "bnb",
    label: "BNB",
    buyCoinAry: ["bnb"],
    group: "ALTS",
  },
  {
    key: "bitci",
    label: "BITCI",
    buyCoinAry: ["bitci"],
    group: "ALTS",
  },
  {
    key: "matic",
    label: "MATIC",
    buyCoinAry: ["matic"],
    group: "ALTS",
  },
  //zone
  {
    key: "zone",
  },
];

export default tabCfgAry;
